const Spinner = (props: any) => {
  const { className = "" } = props;
  return <div className={`flex justify-center items-center h-full w-full ${className}`}>
    <span className={`spinner`}></span>
  </div>
};
export default Spinner;
